import { render, staticRenderFns } from "./NThCongressmanAssemblyTable.vue?vue&type=template&id=0c81ee9f&scoped=true"
import script from "./NThCongressmanAssemblyTable.vue?vue&type=script&lang=js"
export * from "./NThCongressmanAssemblyTable.vue?vue&type=script&lang=js"
import style0 from "./NThCongressmanAssemblyTable.vue?vue&type=style&index=0&id=0c81ee9f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c81ee9f",
  null
  
)

export default component.exports